// src/redux/sentiment/sentimentAPI.js
import apiClient from "../authentication/utils/core/axios";

const SentimentAPI = {
  async fetchStockSentiment(ticker, timeframe = "all") {
    if (!ticker || typeof ticker !== "string" || ticker.trim() === "") {
      throw new Error("Ticker is required for sentiment fetch");
    }

    try {
      const response = await apiClient.get(`/sentimentaggs/${ticker}`, {
        params: { timeframe },
      });
      return { ticker, timeframe, data: response.data };
    } catch (err) {
      const message =
        err.response?.data?.detail || err.message || "Failed to fetch sentiment";
      throw new Error(message);
    }
  },

  /**
   * Batched sibling of fetchStockSentiment -- one HTTP request for N tickers
   * instead of N. Built for the Dashboard's watchlist tiles, which previously
   * fired one individual request per symbol (up to ~50 per page load). See
   * Technical_Docs/13_FIX_HISTORY.md's seventy-second pass.
   * @param {string[]} tickers
   * @param {string} timeframe
   * @returns {Promise<{tickers: string[], timeframe: string, data: Record<string, object>}>}
   */
  async fetchStockSentimentBatch(tickers, timeframe = "all") {
    if (!tickers?.length) return { tickers: [], timeframe, data: {} };

    try {
      const response = await apiClient.get(`/sentimentaggs/batch`, {
        params: { tickers: tickers.join(","), timeframe },
      });
      return { tickers, timeframe, data: response.data ?? {} };
    } catch (err) {
      const message =
        err.response?.data?.detail || err.message || "Failed to fetch batch sentiment";
      throw new Error(message);
    }
  }
};

export default SentimentAPI;
